import createVueApp from '@phoenix/createVueApp';
import FindWatchReferenceModal from '@maison/components/organisms/modals/FindWatchReferenceModal.vue';

const app = createVueApp();
app.component('FindWatchReferenceModal', FindWatchReferenceModal);
app.mount('#phoenix-find-watch-reference-modal');
